export const GHOST_BUMP_LIMIT = 1;

export const getGhostBumpState = (game) => {
  const owned = !!game.relics?.includes('ghostBump');
  const used = game.ghostBump?.used === true;
  const available = owned && !used;
  const canUse =
    available &&
    game.phase === 'bossRolled' &&
    !Number.isInteger(game.bossLandingIndex);
  return {
    owned,
    used,
    available,
    // Ghost Bump is always ready when owned; it is spent only after a bump.
    armed: false,
    canUse,
  };
};

export const startGhostBumpThrow = (game) => {
  if (
    !getGhostBumpState(game).owned ||
    game.phase !== 'bossRolled' ||
    Number.isInteger(game.bossLandingIndex) ||
    game.ghostBump?.throwRound === game.bossRound
  )
    return game;
  return {
    ...game,
    ghostBump: { ...game.ghostBump, throwRound: game.bossRound },
  };
};

export const activateGhostBump = (game) => {
  if (!getGhostBumpState(game).canUse) return game;
  return {
    ...game,
    ghostBump: { ...game.ghostBump, armed: false, used: true },
  };
};
